import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { useHashTab } from "../../../../hooks/useHashTab"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { DeviceFamilyGet } from "../../../models/DeviceFamily"
import { FamilyDetails } from "./details_tab/FamilyDetails"

const returnURL = "/devices#families"

export function FamilyContainer() {
  const { familyId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [deviceFamily, setDeviceFamily] = useState<DeviceFamilyGet>()

  useEffect(() => {
    if (familyId) {
      digitalManagerApi
        .get<DeviceFamilyGet>(`/deviceFamilies/${familyId}`)
        .then((res) => {
          setDeviceFamily(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [familyId, navigate])

  if (!familyId) {
    return <Navigate to={returnURL} />
  }

  if (!deviceFamily) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: deviceFamily.name,
    label: "Device Family",
    subtitle: deviceFamily.name,
    hideCopyToClipboard: true,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <FamilyDetails deviceFamily={deviceFamily} setDeviceFamily={setDeviceFamily} />
      )}
    </div>
  )
}
